import treeimg from "../../../assets/images/Diagram5.png";
import treeimg1 from "../../../assets/images/Diagram7.png"

function CTDDMFPage() {
  return (
    <>
      <div className="flex items-center gap-2 mb-8">
        <span className="w-4 h-4 rounded-full bg-sky-300 flex-shrink-0"></span>
        <h3 className="text-lg font-semibold text-[#05326D]">
          CTD DMF Submission Services
        </h3>
      </div>

      <div className="w-full bg-[#f4faff] px-4 py-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          <img
            src={treeimg1}
            alt="Right Diagram"
            className="w-full"
          />
          <img
            src={treeimg}
            alt="Left Diagram"
            className="w-full"
          />
        </div>
      </div>

      <h4 className="text-md font-bold text-[#05326D] mb-4">
        Global Regulatory Solutions for Drug Master File Compliance
      </h4>
      <p className="text-[#05326D] mt-4">At FDAc Consultancy, we specialize in delivering high-quality, globally compliant Drug Master File (DMF)
        submissions in Common Technical Document (CTD) format. Our services span across major regulatory
        jurisdictions—including US FDA, EU, WHO, China, Japan, and other emerging markets—ensuring seamless
        documentation, publishing, and submission support.   </p>

      <p className="text-[#05326D] mt-4">With a cloud-based infrastructure and round-the-clock operational capability, FDAC empowers pharmaceutical
        manufacturers to meet international regulatory standards efficiently and confidently.</p>

      <hr className="border-t border-gray-300 mb-8 mt-8" />

      <div className="flex items-center gap-2 mb-4">
        <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
        <span className="text-[16px] font-bold text-[#05326D]">
          What Is a CTD DMF?
        </span>
      </div>

      <p className="text-[#05326D] mb-4 mt-2">A Drug Master File (DMF) is a confidential dossier that contains detailed information about the manufacturing,
        processing, packaging, and storage of Active Pharmaceutical Ingredients (APIs) and related materials. Structured
        in CTD format as per ICH guidelines, DMFs are referenced in drug product applications but are not formally
        approved or rejected. Instead, they are reviewed by health authorities when cited in dossiers such as NDAs,
        ANDAs, MAAs, or other regulatory filings. </p>

      <h4 className="text-md font-bold text-[#05326D] mb-4 ">
        DMFs typically consist of two parts:
      </h4>
      <p className="text-[#05326D] mt-2">- Applicant’s/Open Part (AP/OP): Shared with the applicant for inclusion in the drug product dossier </p>
      <p className="text-[#05326D] mt-2">-  Restricted/Closed Part (RP/CP): Submitted confidentially to regulatory authorities for technical evaluation</p>

      <div className="flex items-center gap-2 mb-4 mt-4">
        <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
        <span className="text-[16px] font-bold text-[#05326D]">
          FDAC’s CTD DMF Services
        </span>
      </div>

      <h4 className="text-md font-semibold text-[#05326D] mb-4">
        DMF Authoring & Documentation
      </h4>

      <p className="ml-2 mt-2 text-[#05326D]">- DMF Due Diligence & Technical Audits</p>
      <p className="ml-2 mt-2 text-[#05326D]">- Conversion from Paper/CTD to eCTD Format</p>
      <p className="ml-2 mt-2 text-[#05326D]">- Authoring of Modules 1, 2, and 3 for APIs, Intermediates, and Semi-Finished Dosage Forms</p>
      <p className="ml-2 mt-2 text-[#05326D]">- Preparation of AP & RP Sections for Global Markets</p>
      <p className="ml-2 mt-2 text-[#05326D]">- Country-Specific DMF Preparation (China, Japan, WHO Prequalification, etc.)</p>
      <p className="ml-2 mt-2 text-[#05326D]">- Support for CTD, NeeS, and eCTD Formats</p>

      <div className="flex items-center gap-2 mb-4 mt-4">
        <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
        <span className="text-[16px] font-bold text-[#05326D]">
          eCTD Publishing & Technical Support
        </span>
      </div>

      <p className="ml-2 mt-2 text-[#05326D]">- eCTD Compilation, QC Review, Validation & Hosting</p>
      <p className="ml-2 mt-2 text-[#05326D]">- Baseline Conversion & Lifecycle Management</p>
      <p className="ml-2 mt-2 text-[#05326D]">- Importing & Cloning of Existing Applications</p>
      <p className="ml-2 mt-2 text-[#05326D]">- PDF Optimization: OCR, Font Embedding, Bookmarking, Hyperlinking</p>
      <p className="ml-2 mt-2 text-[#05326D]">- Compliance with Global Regulatory Requirements</p>

      <div className="flex items-center gap-2 mb-4 mt-4">
        <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
        <span className="text-[16px] font-bold text-[#05326D]">
          DMF Submission Services
        </span>
      </div>

      <p className="ml-2 mt-2 text-[#05326D]">- Submission via Health Authority Portals or Secure Cloud Links</p>
      <p className="ml-2 mt-2 text-[#05326D]">- Original DMF Filing, Amendments, Annual Reports, and Query Responses</p>
      <p className="ml-2 mt-2 text-[#05326D]">- End-to-End Project Management for Timely and Compliant Submissions</p>

      <div className="flex items-center gap-2 mb-4 mt-4">
        <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
        <span className="text-[16px] font-bold text-[#05326D]">
          DMF Lifecycle Management
        </span>
      </div>

      <p className="ml-2 mt-2 text-[#05326D]">- Preparation and Publishing of Revisions & Renewals </p>
      <p className="ml-2 mt-2 text-[#05326D]">- Query Response Support for Amendment Filings </p>
      <p className="ml-2 mt-2 text-[#05326D]">- Strategic Updates to Ensure Continued Compliance</p>

      <hr className="border-t border-gray-300 mb-8 mt-8" />

      <div className="flex items-center gap-2 mb-4 mt-4">
        <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
        <span className="text-[16px] font-bold text-[#05326D]">
          Why FDAC?
        </span>
      </div>



      <p className="ml-2 mt-2 text-[#05326D]">- Global reach with local regulatory insight </p>
      <p className="ml-2 mt-2 text-[#05326D]">- Cloud-based systems for secure, 24/7 operations  </p>
      <p className="ml-2 mt-2 text-[#05326D]">- Expert team with proven success across US, EU, WHO, China, Japan, and ROW markets </p>
      <p className="ml-2 mt-2 text-[#05326D]">- Customized solutions aligned with ICH and country-specific guidelines </p>
      <p className="ml-2 mt-4 text-[#05326D]">


        FDAC is your trusted partner for DMF strategy, authoring, publishing, and submission—ensuring your
        documentation is accurate, confidential, and positioned for regulatory success.</p>
    </>

  );
}

export default CTDDMFPage;
